import React from 'react';
// ANTD
import Form from 'antd/lib/form';
import Switch from 'antd/lib/switch';
import DatePicker from 'antd/lib/date-picker';
// COMPONENTS
import FormItem from 'components/common/FormItem';
import Row from 'components/common/Row';
import Col from 'components/common/Col';

class ScheduledInvoiceForm extends React.PureComponent {
  render() {
    const { onChange, scheduleInvoice } = this.props;
    return (
      <Form>
        <Row style={{ height: 150 }}>
          <Col xs={24} sm={12}>
            <FormItem label="Schedule to Send Later?">
              <Switch
                onChange={value => onChange({ scheduleInvoice: value })}
                checked={scheduleInvoice || false} // true/false
                size="large"
              />
            </FormItem>
          </Col>
          <Col xs={24} sm={12}>
            {scheduleInvoice && (
              <FormItem label="Which day?">
                <DatePicker
                  onChange={scheduledInvoiceDate => onChange({ scheduledInvoiceDate })}
                  value={this.props.scheduledInvoiceDate}
                  size="large"
                />
              </FormItem>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

// ScheduledInvoiceForm.propTypes = {
//     invoiceId: PropTypes.String.isRequired()
// }

ScheduledInvoiceForm.defaultProps = {
  scheduleInvoice: false,
  onChange: () => {},
};

export default ScheduledInvoiceForm;



// WEBPACK FOOTER //
// ./src/components/forms/ScheduledInvoiceForm/index.js